module.exports = __webpack_public_path__ + "static/img/未开始.704f865.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/未开始.png
// module id = 9u3E
// module chunks = 1